import PasswordRules from '@/components/PageSpecific/change-password/PasswordRules';
import ActionButton from '@/components/Reusable/Button/ActionButton';
import ObscuredInput from '@/components/Reusable/Formik/ObscuredInput';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';

export default function NewPasswordForm({
  formData,
  handleInputChange,
  loading,
  handleNewPasswordSubmit,
}) {
  const theme = useTheme();
  const [isValid, setIsValid] = useState(false);

  return (
    <Box
      component='form'
      onSubmit={(e) => {
        e.preventDefault();
        handleNewPasswordSubmit();
      }}
      sx={{
        px: { xs: 2, sm: 3, md: 4 },
        py: 3,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* “Create a New Password” Heading (mb:3 now) */}
      <Typography
        component='h1'
        variant='h1'
        sx={{
          fontWeight: 700,
          fontSize: '1.5rem',
          color: theme.palette.text.primary,
          mb: 3, // ← increased from 2 to 3
          lineHeight: 1.1,
        }}
      >
        Create a New Password
      </Typography>

      {/* New Password Field */}
      <ObscuredInput
        fullWidth
        variant='outlined'
        label='New Password'
        name='newPassword'
        value={formData.newPassword}
        onChange={handleInputChange}
        placeholder='Enter your new password'
        InputLabelProps={{
          sx: {
            color: theme.palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
          },
        }}
        sx={{
          mb: 2,
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            background: theme.palette.background.default,
          },
        }}
      />

      {/* Repeat New Password Field */}
      <ObscuredInput
        fullWidth
        variant='outlined'
        label='Repeat New Password'
        name='newRepeat'
        value={formData.newRepeat}
        onChange={handleInputChange}
        placeholder='Re-enter your new password'
        InputLabelProps={{
          sx: {
            color: theme.palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
          },
        }}
        sx={{
          mb: 2,
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            background: theme.palette.background.default,
          },
        }}
      />

      {/* Password Rules Validation */}
      <Box sx={{ mb: 3 }}>
        <PasswordRules formData={formData} setIsValid={setIsValid} />
      </Box>

      {/* "Change Password" Button */}
      <ActionButton
        type='submit'
        loading={loading}
        disabled={loading || !isValid}
        sx={{ mb: 2 }}
      >
        Change Password
      </ActionButton>
    </Box>
  );
}
